
import { useMemo } from 'react';
import TimelineFaultEvents from '../../../../../CommonComponents/timeline-fault-events/TimelineFaultEvents';
import { TimelineFaultsContainer } from '../../../../../CommonComponents/timeline/Timeline';
import useContacts from '../../../../hooks/useContacts';
import useSatellite from '../../../../hooks/useSatellite';

const FaultEvents = () => {

    const { injectedFaultList } = useContacts();
    const { selected_satellite } = useSatellite();
    const allFaults = useMemo(() => injectedFaultList.flatMap(fault => fault.satellites), [injectedFaultList, selected_satellite])
    const faults = useMemo(() => selected_satellite ? allFaults?.find(fault => fault.satId === selected_satellite?.value?.satelliteId)?.['definedFaultTasks'] || [] : [], [selected_satellite, allFaults])

    return (
        <TimelineFaultsContainer>
            <TimelineFaultEvents faults={faults} />
        </TimelineFaultsContainer>
    )

}

export default FaultEvents